/**
 * ConnectivityButton.tsx — the single top-right connectivity affordance on
 * the home view (start page). Borderless link-style in both states:
 * green wifi when everything is configured, red slashed wifi when not.
 */
import { WifiHigh, WifiSlash } from '@phosphor-icons/react';

export function ConnectivityButton({
  connected,
  onClick,
}: {
  connected: boolean;
  onClick: () => void;
}): JSX.Element {
  return (
    <button
      type="button"
      className={`connectivity-btn${connected ? ' ok' : ' bad'}`}
      onClick={onClick}
      title={
        connected
          ? 'Connectivity — connected. Open to review or change any step.'
          : 'Connectivity — not connected. Open the setup wizard.'
      }
    >
      {connected ? (
        <WifiHigh size={15} weight="bold" />
      ) : (
        <WifiSlash size={15} weight="bold" />
      )}
      <span></span>
    </button>
  );
}
